import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '../src/Modules/App';
import { AuthProvider } from 'context/AuthProvider';

const root = createRoot(document.getElementById('app'));
root.render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>
);
